import { ChangeDetectionStrategy, Component, Input, OnInit, OnDestroy } from '@angular/core';
import { SubscriptionCollector } from '@draeger-academy/common';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { NavigationUiUtilsService } from '../../navigation-ui-utils.service';

@Component({
    selector: 'da-desktop-navigation',
    templateUrl: './desktop-navigation.component.html',
    styleUrls: ['./desktop-navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DesktopNavigationComponent implements OnInit, OnDestroy {
    public MAX_MAIN_ITEMS = 2;
    public MAX_BUSINESSFIELD_ITEMS = 3;
    public MAX_BUSINESSFIELD_COLUMNS = 3;
    public MAX_LINKS_PER_COLUMN = 10;
    @Input() translations: object;
    @SubscriptionCollector() private _subscriptions;
    private _$navigationData: BehaviorSubject<any[]> = new BehaviorSubject(null);
    private _$model: BehaviorSubject<any> = new BehaviorSubject({});

    constructor(private _navigationUiUtilsService: NavigationUiUtilsService) {}

    @Input()
    set navigationData(value: any[]) {
        this._$navigationData.next(value);
    }

    public get navigationData$(): Observable<any[]> {
        return this._$navigationData.asObservable();
    }

    public get model$(): any {
        return this._$model.asObservable();
    }

    ngOnInit() {
        this._$model.next({});
        this._setInitialNavValues();
    }

    public resetNavigationSelection() {
        this._setInitialNavValues();
    }

    public selectOnlyClicked(index: number, navigationEntry) {
        this._subscriptions.push(
            this.model$.pipe(distinctUntilChanged()).subscribe((data) => {
                for (const key in data) {
                    if (data.hasOwnProperty(key) && data[key].hasOwnProperty('selected')) {
                        if (key !== 'sitenavigationTopSegmentSelected' + index) {
                            data[key].selected = false;
                            break;
                        }
                    }
                }
                this._$model.next(data);
            })
        );
    }

    public getCssClassByBusinessField(businessField: string, suffix: string): string {
        return 'business_field_color_draegerblue_' + suffix;
    }

    public resetModel() {
        this._setInitialNavValues();
    }

    ngOnDestroy() {
        this._subscriptions.forEach((data) => {
            if (data) {
                data.unsubscribe();
            }
        });
    }

    private _setInitialNavValues() {
        this._$model.next({
            sitenavigationTopSegmentSelected0: {
                selected: false
            },
            sitenavigationTopSegmentSelected1: {
                selected: false
            },
            siteNavigationSecondLevelSelectedSegment0: 'navbartogglesegment0level0item0',
            siteNavigationSecondLevelSelectedSegment1: 'navbartogglesegment1level1item0',
            siteNavigationThirdLevelSelectedSegment0: '',
            siteNavigationThirdLevelSelectedSegment1: ''
        });
    }
}
